/* istanbul ignore file */
import React from 'react';

import { ROUTES } from '../../constants';
import App from './components/App';

const config = {
  name: 'Details',

  apiUrl: process.env.API_URL,
  apiKey: process.env.API_KEY,
  staticDataEndpoint: process.env.STATIC_DATA_ENDPOINT,
  rnrEndpoint:process.env.RNR_ENDPOINT,
  rnrApiKey:process.env.REACT_APP_CLIENT_ID,
  languagesListEndpoint:process.env.LANGUAGES_LIST_ENDPOINT,
  ccesEndpoint:process.env.CCES_ENDPOINT,
  ccesApiKey:process.env.CCES_API_KEY,
  fastSpringUrl:process.env.FAST_SPRING_URL,
  ccMostPopularTagsEndpoint:process.env.CC_MOST_POPULAR_TAGS_ENDPOINT,
  appRegistryUrl:process.env.APP_REGISTRY_URL,
  installEndpoint: process.env.INSTALLATION_SERVICE_URL,
  appRegistryEndpoint: process.env.APP_REGISTRY_URL,
  basepath: ROUTES.EXC,
  ROUTES,
};

const DetailsPage = () => <App key="details-app" config={config} />;

export default DetailsPage;
